import {
  COMMON_SAVE_CLIENT_DATA_BEGIN,
  COMMON_SAVE_CLIENT_DATA_SUCCESS,
  COMMON_SAVE_CLIENT_DATA_FAILURE,
  COMMON_SAVE_CLIENT_DATA_DISMISS_ERROR,
  COMMON_SAVE_CLIENT_DATA_CLEAN,
} from './constants'

export function saveClientData(clientData) {
  return async (dispatch) => {
    dispatch({
      type: COMMON_SAVE_CLIENT_DATA_BEGIN,
    })
    try {
          dispatch({
              type: COMMON_SAVE_CLIENT_DATA_SUCCESS,
              data: clientData
          })
     } catch (error) {
        dispatch({
          type: COMMON_SAVE_CLIENT_DATA_FAILURE,
          data: { error },
        })
    }
  }
}

export function dismissSaveClientDataError() {
  return {
    type: COMMON_SAVE_CLIENT_DATA_DISMISS_ERROR,
  }
}

export function cleanSaveClientData() {
  return {
    type: COMMON_SAVE_CLIENT_DATA_CLEAN,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SAVE_CLIENT_DATA_BEGIN:
      return {
        ...state,
        saveClientDataPending: true,
      }

    case COMMON_SAVE_CLIENT_DATA_SUCCESS:
      return {
        ...state,
        saveClientDataPending: false,
        saveClientDataError: false,
        client: action.data,
      }

    case COMMON_SAVE_CLIENT_DATA_FAILURE:
      return {
        ...state,
        saveClientDataPending: false,
        saveClientDataError: action.data.error,
      }

    case COMMON_SAVE_CLIENT_DATA_DISMISS_ERROR:
      return {
        ...state,
        saveClientDataError: false,
      }

    case COMMON_SAVE_CLIENT_DATA_CLEAN:
      return {
        ...state,
        saveClientDataPending: false,
        saveClientDataError: false,
        client: {},
      }

    default:
      return state
  }
}
